import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import { useFormSubmit } from '@/features/settings/components/AddPrinterModal/form'
import { OnFormSubmit } from '@/features/settings/components/AddPrinterModal/form/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface ActionButtonsProps {
    onFormSubmit: OnFormSubmit
    onCancel: () => void
}

const ActionButtons: FC<ActionButtonsProps> = ({ onFormSubmit, onCancel }) => {
    const { t } = useTranslation()

    const [{ isValid, isSubmitting }, onConfirm] = useFormSubmit(onFormSubmit)

    return (
        <View style={styles.container}>
            <ConfirmButton
                label={t('actions.continue')}
                disabled={!isValid || isSubmitting}
                onConfirm={onConfirm}
            />
            <CancelButton onPress={onCancel} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingTop: 8,
        gap: 16,
        justifyContent: 'center',
    },
})

export default ActionButtons
